export const ARROW_LEFT = 37
export const ARROW_RIGHT = 39
export const ESCAPE = 27
export const SPACE = 32
export const M_KEY = 77
